import React from 'react';
import {View, StyleSheet} from 'react-native';
import {useTranslation} from 'react-i18next';
import DatePickerInput from '../../../components/common/DatePickerInput';
import {spacing} from '../../../theme';

const DateRangeFilter = ({fromDate, toDate, onFromChange, onToChange}) => {
  const {t} = useTranslation();

  return (
    <View style={styles.container}>
      <DatePickerInput
        label={t('report.dateFrom')}
        value={fromDate}
        onChangeText={onFromChange}
        maxDate={toDate}
        style={styles.dateInput}
      />
      <DatePickerInput
        label={t('report.dateTo')}
        value={toDate}
        onChangeText={onToChange}
        minDate={fromDate}
        style={styles.dateInput}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
    gap: spacing.sm,
  },
  dateInput: {
    flex: 1,
  },
});

export default DateRangeFilter;
